import React from 'react';

import {ShoppingItem as UdemyShoppingItem} from '@udemy/shopping';

import {CertificationVoucherItem} from './certification-voucher-item.react.component';
import styles from './shopping-item.module.less';
import {ShoppingItem} from './shopping-item.react-component';
import {ActionHandlers, ActionSupportedLayoutsProps, ItemTypeConfig} from './types';

export interface ItemsProps {
    item: UdemyShoppingItem;
    itemType: ItemTypeConfig;
    index: number;
    listName: string;
    actions: ActionHandlers;
    performanceMarkName?: string;
    actionsLayout: ActionSupportedLayoutsProps;
}

export const Items: React.FC<ItemsProps> = ({
    item,
    itemType,
    index,
    performanceMarkName,
    actionsLayout,
    ...rest
}) => {
    return (
        <div className={styles['shopping-item-wrapper']}>
            {itemType
                .buildShoppingItems(item)
                .map((cartItem, i) =>
                    itemType.type === 'certification_voucher' ? (
                        <CertificationVoucherItem
                            item={cartItem}
                            index={index}
                            actionsLayout={actionsLayout}
                            {...rest}
                        />
                    ) : (
                        <ShoppingItem
                            key={i}
                            item={cartItem}
                            index={index}
                            performanceMarkName={index === 0 ? performanceMarkName : ''}
                            actionsLayout={actionsLayout}
                            {...rest}
                        />
                    ),
                )}
        </div>
    );
};
